<template>
  <v-card elevation="0" rounded="lg" outlined class="pa-0 mx-0 mt-8">
    <v-card-title class="text-h5 font-weight-bold"> Settings </v-card-title>
    <v-card-text class="pa-5">
      <div class="text-body-1 black--text font-weight-medium pb-8">
        Company Profile Preview
      </div>
      <v-row justify="center" align="center">
        <v-col cols="12" md="7">
          <v-card outlined elevation="0">
            <v-btn
              class="layer-above"
              absolute
              right
              v-if="isEditing"
              icon
              @click="openImage"
            >
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <img
                    :src="require('../../assets/images/icon/Edit.svg')"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <span>
                  Edit Company Image
                </span>
              </v-tooltip>
            </v-btn>
            <v-img
              width="600px"
              contain
              max-height="400px"
              :src="
                currentImage ||
                require('../../assets/images/recruiter/default.svg')
              "
            >
              <Loader v-if="imageEdit"></Loader>
            </v-img>
            <input
              type="file"
              ref="avatarFile"
              style="display: none"
              accept="image/png"
              @change="uploadAttachmentSave"
            />
          </v-card>
        </v-col>
        <v-col cols="12" md="5" class="text-body-1 d-flex flex-column">
          <v-row class="">
            <v-col>
              <div class="font-weight-medium black--text">Company Name:</div>
            </v-col>
            <v-col>
              <v-text-field
                v-if="isEditing"
                dense
                :hidden="!isEditing"
                v-model="updatedName"
                :value="updatedName"
              >
              </v-text-field>
              <div class="black--text" v-else>
                {{ customer?.getName() || "Not Set" }}
              </div>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <div class="font-weight-medium">Description:</div>
            </v-col>
            <v-col>
              <div>Google</div>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col>
              <div class="font-weight-medium black--text">Hiring Plan:</div>
            </v-col>
            <v-col>
              <div class="black--text">{{ hiringPlan }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="px-5">
      <v-btn
        outlined
        class="px-5 py-3 text-none"
        @click="handleEditBtn"
      >
        {{ isEditing ? "Cancel" : "Edit" }}
      </v-btn>
      <v-btn
        v-if="isEditing"
        color="primary"
        class="px-5 py-3 text-none text-body-1"
        @click="updateCustomerDetails"
        :loading="saving"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import Loader from "../../components/Loader.vue";
export default {
  props: {},
  data() {
    return {
      isEditing: false,
      updatedName: "",
      currentImage: "",
      imageEdit: false,
      saving: false,
    };
  },
  computed: {
    ...mapState("customer", ["customer", "customerImgUrl"]),
    ...mapGetters("customer", ["hiringPlanKeys", "prettyHiringPlans"]),
    companyImage() {
      if (!!this.customer?.getCompanyLogoUrl()) {
        return this.customer?.getCompanyLogoUrl();
      }
    },
    hiringPlan() {
      return this.prettyHiringPlans[
        this.hiringPlanKeys[this.customer?.getHiringPlan()]
      ];
    },
    companyDomain() {
      return this.customer?.getCompanyDomain();
    },
  },
  components: { Loader },
  methods: {
    ...mapActions("customer", [
      "fetchCustomer",
      "updateCustomer",
      "uploadCompanyImage",
    ]),
    updateCustomerDetails() {
      this.saving = true;
      this.updateCustomer({
        name: this.updatedName,
        imgUrl: this.currentImage,
      }).then((r) => {
        this.imageEdit = false;
        this.isEditing = false;
        this.saving = false;
      });
    },
    handleEditBtn() {
      this.isEditing = !this.isEditing;
      this.updatedName = this.customer?.getName();
      this.currentImage = this.customer?.getCompanyLogoUrl();
    },
    openImage(event) {
      //console.log("Event .. ", event);
      console.log(this.$refs.avatarFile);
      this.$refs.avatarFile.click();
    },
    async uploadAttachmentSave(event) {
      this.imageEdit = true;
      // console.log("files", await this.$refs.avatarFile.files[0].text());
      this.encodeImageFileAsURL(
        await this.$refs.avatarFile,
        this.uploadCompanyImage
      );
    },
    async encodeImageFileAsURL(element, callback) {
      var file = element.files[0];
      var reader = new FileReader();
      reader.onloadend = function () {
        callback({ image: reader.result.replace(/^data:image.+;base64,/, "") });
      };
      reader.readAsDataURL(file);
    },
  },
  created() {
    if (!this.customer) {
      this.fetchCustomer().then((r) => {
        console.log(`customer`, this.customer?.toObject());
      });
    }
    this.updatedName = this.customer?.getName();
    this.currentImage = this.customer?.getCompanyLogoUrl();
    console.log(this.updatedName, this.currentImage);
  },
  watch: {
    customer(v) {
      this.updatedName = this.customer?.getName();
      this.currentImage = this.customer?.getCompanyLogoUrl();
    },
    customerImgUrl(i) {
      this.currentImage = i;
      this.imageEdit = false;
    },
  },
};
</script>
<style scoped>
.layer-above {
  z-index: 20;
}
</style>
